import React from 'react';

const BreakFree = () => {
  return (
    <section className="story-solution-section">
      <div className="solution-content-wrapper">
        <div className="solution-main-heading">
          <h2>But what if you could <span className="highlight-text">break free?</span></h2>
        </div>

        <div className="solution-grid">
          {/* Left Column - Questions */}
          <div className="solution-card questions-card">
            <div className="card-header">
              <h3>Imagine if...</h3>
            </div>
            <div className="question-list">
              <div className="question-item">
                <span className="q-marker">→</span>
                <p>You <strong>owned your CRM</strong>—completely</p>
              </div>
              <div className="question-item">
                <span className="q-marker">→</span>
                <p>It was built around <strong>YOUR process</strong>, not theirs</p>
              </div>
              <div className="question-item">
                <span className="q-marker">→</span>
                <p>Growing your team didn't mean growing your monthly bill</p>
              </div>
            </div>
          </div>

          {/* Right Column - Promise */}
          <div className="solution-card promise-card">
            <div className="promise-header">
              <h3>That's not a fantasy.<br/><span className="accent">That's what we build.</span></h3>
            </div>
            <ul className="benefits-grid">
              <li>
                <span className="benefit-icon">✓</span>
                <span>A custom CRM designed for your exact workflow</span>
              </li>
              <li>
                <span className="benefit-icon">✓</span>
                <span>Built on open-source foundations you control</span>
              </li>
              <li>
                <span className="benefit-icon">✓</span>
                <span>One investment. Zero subscriptions. Infinite possibilities</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom - No More Section */}
        <div className="solution-no-more-section">
          <h4>Say goodbye to:</h4>
          <div className="no-more-grid">
            <div className="no-more-item">
              <span className="x-icon">✕</span>
              <p>Bending your business to fit someone else's template</p>
            </div>
            <div className="no-more-item">
              <span className="x-icon">✕</span>
              <p>Paying rent on software you'll never truly own</p>
            </div>
            <div className="no-more-item">
              <span className="x-icon">✕</span>
              <p>Choosing between growth and cost control</p>
            </div>
          </div>
        </div>

        <div className="solution-final-statement">
          <p>Your business deserves better. <strong>Let's build something that actually works for you.</strong></p>
        </div>
      </div>
    </section>
  );
};

export default BreakFree;
